/** 后台 UEditor 产出的内容一律以区块标签开头（与后台 PlatformAdmin 的 rich-text.util 同一套判断） */
const BLOCK_START_PATTERN = /^\s*<(p|div|h[1-6]|ul|ol|table|blockquote|pre|section)[\s>]/i;

/**
 * 是否为富文本 (ALL-13956)
 *
 * 弹窗 Banner 文案原本是纯文字（可能夹杂手写 HTML），换行靠 white-space: pre-line；
 * 后台改用富文本编辑器后，新存的内容是 HTML。还没重新保存过的旧 Banner 仍是纯文字，两种都要能显示。
 */
export function isRichTextContent(content: string | null | undefined): boolean {
  return !!content && BLOCK_START_PATTERN.test(content);
}

/**
 * 只替换 href 里的值，其余内容原样保留 (ALL-13956)
 *
 * CTA 按钮的 data-link 要保留 ${domain} 原样，点击时交给 HtmlCtaService 解析成站内路径；
 * 若整段一起替换成完整网址，CTA 会被当成外部链接开新分页。
 */
export function replaceHrefValues(html: string, replace: (url: string) => string): string {
  if (!html) return '';
  return html.replace(
    /(\shref\s*=\s*)(["'])(.*?)\2/gi,
    (_match, prefix, quote, url) => `${prefix}${quote}${replace(url)}${quote}`,
  );
}
